import React, { useState } from 'react'
import { Button, Grid, TextField } from '@mui/material'
import { useRecordContext, useRefresh } from 'react-admin'
import { getCAPQuote } from '../../../../Utils/RestUtils'

const CapFields = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const [isLoadingCap, setIsLoadingCap] = useState(false)

  const handleGetCap = async () => {
    if (!isLoadingCap) {
      setIsLoadingCap(true)

      await getCAPQuote(record.leadContact.vehicle['@id'])
      refresh()
      setIsLoadingCap(false)
    }
  }

  return (
    <React.Fragment>
      <Grid
        item
        xs={2}
        sx={{
          '&.MuiGrid-item': {
            paddingTop: '0',
          },
        }}
      >
        <Button
          className="cap-panel__button cap-panel__button-green"
          disabled={isLoadingCap}
          onClick={handleGetCap}
          fullWidth
        >
          Get Cap
        </Button>
      </Grid>
      <Grid item xs={2}>
        <TextField
          label="Target price"
          disabled
          value={
            record.latestPricingPrediction &&
            record.latestPricingPrediction.targetPrice.toFixed(2)
          }
        />
      </Grid>
    </React.Fragment>
  )
}

export default CapFields
